import React from 'react';
import { Link as RouterLink} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import './links.scss';
import { Icon } from "@ui-kit";

/*
 *<Link to="/home" theme="secondary" size="sm" disabled={true}>
 */

const Link = (props) => { 
  let { 
    theme = 'primary',
    size = 'xl',
    disabled = false,
    to = '', 
    children, 
    iconLeft, 
    iconRight,
    alt = 'image icon',
    className, 
    ...options 
  } = props;

  const defaultDisabled = disabled ? 'disabled' : '';

  const rootClasses = ['link', className, theme, size, defaultDisabled];

  const buildMultiUrl = (url) => {
    let returnedUrl = url.pathname;
    if (url.hasOwnProperty('search')) {
      returnedUrl+=url.search;
    }

    return returnedUrl.concat(url.hash);
  }

  if (to?.hash) {
    return (
      <HashLink
        to={buildMultiUrl(to)}
        {...options} 
        className={rootClasses.join(' ')}
      >
        {iconLeft && <Icon src={iconLeft} alt={alt} />}
        {children}
        {iconRight && <Icon src={iconRight} alt="icon"  className="icon-right"/>}
      </HashLink>
    )
  }

  return (
    <RouterLink 
      to={to} 
      {...options} 
      className={rootClasses.join(' ')}
    >
      {iconLeft && <Icon src={iconLeft} alt="icon"/>}
      {children}
      {iconRight && <Icon src={iconRight} alt="icon"  className="icon-right"/>}
    </RouterLink>
  );
};

export default Link;


/*
<Link size-"lg" to="/" theme="text" className="arrow-right">
  Fill out the brief
</Link>
*/